/* src/app/components/company-datascope-selector/company-datascope-selector.component.scss */
#customerSelector .e-dlg-content {
  padding: 0px;
}
.e-dialog .e-dlg-content {
  padding: 0;
}
.e-footer-content {
  width: 100% !important;
  padding: 5px 16px 20px;
}
button.e-disabled {
  cursor: default;
}
/*# sourceMappingURL=company-datascope-selector.component.css.map */
